// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Rv-z","tooltipWrapper":"Sv-z","icon":"Tv-z","tooltip":"Uv-z","content":"Vv-z"};